import { useMutation } from "react-query";
import { useParams } from "react-router-dom";
import { milestoneRequestChanges } from "../../../../../api-services/projects/milestones";
import {
  FEEDBACK_TYPE,
  feedbackMessage,
} from "../../../../professional/job-requests/hooks/feedbackErrors";
import { useToast } from "../../../../utils/useToast";

export const useMilestoneRequestChanges = (projectId?: string) => {
  const { projectId: paramsProjectId } = useParams();
  const { notifySuccess } = useToast();

  return useMutation(
    (milestoneId: string) =>
      milestoneRequestChanges(projectId ?? paramsProjectId, milestoneId),
    {
      onSuccess() {
        notifySuccess(
          feedbackMessage("milestone changes", FEEDBACK_TYPE.SUBMIT)
        );
      },
    }
  );
};
